<div class="cn-summary py-4 px-1 px-sm-4 position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>

    <div class="cn-summary__header">
        <i class="fas cn-summary__icon"
            [ngClass]="isFullySuccessful ? 'fa-check-circle cn-summary__icon--success' : 'fa-exclamation-triangle cn-summary__icon--warning'"></i>
        <h4 class="cn-summary__title">Resumen de la asociación</h4>
        <p class="cn-summary__subtitle" *ngIf="response">
            Se solicitaron {{response.requestedCount}}
            {{response.requestedCount === 1 ? 'nota crédito' : 'notas crédito'}}
        </p>
    </div>

    <div class="cn-summary__counts" *ngIf="counts.length">
        <div class="cn-summary__count" *ngFor="let count of counts" [attr.data-tone]="count.tone">
            <span class="cn-summary__count-value">{{count.value}}</span>
            <span class="cn-summary__count-label">{{count.label}}</span>
        </div>
    </div>

    <div class="cn-summary__items" *ngIf="items.length; else noItems">
        <div class="cn-summary__item" *ngFor="let item of items" [attr.data-tone]="toneOf(item)">
            <div class="cn-summary__item-head">
                <span class="cn-summary__name">{{item.name}}</span>
                <span class="cn-summary__arrow" *ngIf="item.billId || item.number">→</span>
                <span class="cn-summary__bill" *ngIf="item.billId || item.number">
                    {{item.billId ? item.billId : item.number}}
                </span>
                <span class="cn-summary__status" [matTooltip]="statusDetail(item.status)">
                    {{statusLabel(item.status)}}
                </span>
            </div>
            <p class="cn-summary__message" *ngIf="item.message">{{item.message}}</p>
            <div class="cn-summary__fields" *ngIf="item.differentFields && item.differentFields.length">
                <span class="cn-summary__fields-label">Campos con diferencia:</span>
                <span class="cn-summary__field" *ngFor="let field of item.differentFields">
                    {{fieldLabel(field)}}
                </span>
            </div>
        </div>
    </div>

    <ng-template #noItems>
        <div class="alert alert-info mt-3" role="alert">
            <p class="mb-0">El servicio no devolvió detalle por nota crédito.</p>
        </div>
    </ng-template>

    <div class="w-100 mt-4 button-container">
        <button type="button" mat-raised-button class="bg-color-primary button-width-auto" color="primary"
            (click)="dialogRef.close()">
            Entendido
        </button>
    </div>
</div>
